import { createRoute } from '@tanstack/react-router'
import { Route as rootRoute } from '@/app/__root'
import { ROUTES } from '@/shared/constants/routes'
import { OnboardingPetFormPage } from './page.onboarding.pet-form'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.ONBOARDING_PET_FORM,
  component: OnboardingPetFormPage,
})
